// extracted by mini-css-extract-plugin
export default {"loginMainFrame":"Login_loginMainFrame__7qXf9","submitButton":"Login_submitButton__6izv4"};